<template>
  <div class="videoPlayback-page">
    <div class="cross" v-if="screenType == 0"></div>
    <div v-else class="vertical">
      <div
        class="vertical-item"
        v-for="(item, index) in list"
        :key="index"
        @click="clickItem(item)"
      >
        <div class="img-content">
          <van-image
            class="img"
            :src="require('../../../../assets/themes/img/teasLogin/bg.jpg')"
            @click="clickImg"
          />
          <div class="bofang"><dsf-icon class="icon-ln_jiantouyou" /></div>
        </div>
        <div class="title">{{ "校园景致" }}</div>
      </div>
    </div>
    <van-popup class="videoPlayback-page-popup" v-model="show" position="center" get-container="#app"  :closeable="true">
      <div class="video-content">
        <video
          class="video"
          controls="controls"
          autoplay="autoplay"
        >
          <source src="/i/movie.ogg" type="video/ogg" />
        </video>
        <!-- <div class="guanbi"><dsf-icon class="icon-guanbi2" /></div> -->
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "videoPlayback",
  data() {
    return {
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 10, 11, 12, 13],
      screenType: 0, //屏幕类型：0为横向，1为纵向
      show: false,
    };
  },
  created() {
    this.screenType = this.$route.meta.screenType;
    this.getData();
  },
  methods: {
    getData() {
      // this.$http
      //   .get(this.url, {
      //     pageSize: this.maxTags,
      //   })
      //   .then(({ data }) => {
      //     if (data && data.success) {
      //       this.swiperList = data.data;
      //     }
      //   })
      //   .catch(() => {
      //     this.swiperList = [];
      //   });
    },
    clickItem(item) {
      this.show = true;
    },
  },
};
</script>

<style>
</style>